(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-general_content_with_left_nav"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Get all elements with IDs to track
  const sections = document.querySelectorAll('div.content-block[id]');
  
  // Get all anchor tags in the navigation
  const navLinks = document.querySelectorAll('ul.left-nav a');

  // Function to add active class based on scroll position
  function onScroll() {
    let found = false;

    sections.forEach((section, index) => {
      // Get the position of the element in relation to the viewport
      const rect = section.getBoundingClientRect();
      const sectionHeight = rect.height;
      const viewportHeight = window.innerHeight;

      // Check if the element is 50% visible within the viewport
      if (rect.top <= viewportHeight * 0.7 && rect.top + sectionHeight > viewportHeight * 0.7) {
        if (!found) {
          // Remove 'active' class from all nav links
          navLinks.forEach(link => link.classList.remove('active'));

          // Add 'active' class to the corresponding link
          navLinks[index].classList.add('active');
          found = true;
        }
      }
    });
  }
 
  // Attach the scroll event listener
  window.addEventListener('scroll', onScroll);

  // Run the function once to set the initial state
  onScroll();
});


  } catch(e) { console.error(e); }
})();
})();
